/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} EditorInputs */

const en_editor = /** @type {(inputs: EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

const fr_editor = /** @type {(inputs: EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éditeur`)
};

const de_editor = /** @type {(inputs: EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

const it_editor = /** @type {(inputs: EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redattore`)
};

const ru_editor = /** @type {(inputs: EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактор`)
};

const es_editor = /** @type {(inputs: EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

const zh_cn2_editor = /** @type {(inputs: EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑`)
};

const ja_editor = /** @type {(inputs: EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エディタ`)
};

const hi_editor = /** @type {(inputs: EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादक`)
};

const pt_pt2_editor = /** @type {(inputs: EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

/**
* | output |
* | --- |
* | "Editor" |
*
* @param {EditorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor = /** @type {((inputs?: EditorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<EditorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor(inputs)
	if (locale === "de") return de_editor(inputs)
	if (locale === "it") return it_editor(inputs)
	if (locale === "ru") return ru_editor(inputs)
	if (locale === "es") return es_editor(inputs)
	if (locale === "zh-CN") return zh_cn2_editor(inputs)
	if (locale === "ja") return ja_editor(inputs)
	if (locale === "hi") return hi_editor(inputs)
	if (locale === "pt-PT") return pt_pt2_editor(inputs)
	return en_editor(inputs)
});